var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5254 15.25L20.7504 11.475C19.9587 10.6833 18.8671 10.2583 17.7504 10.3166L13.5837 10.5166C11.9171 10.5916 10.5921 11.9166 10.5087 13.575L10.3087 17.7416C10.2587 18.8583 10.6754 19.95 11.4671 20.7416L15.2421 24.5166C16.7921 26.0666 19.3087 26.0666 20.8671 24.5166L24.5254 20.8583C26.0837 19.3166 26.0837 16.8 24.5254 15.25ZM15.9171 18.3166C14.5921 18.3166 13.5171 17.2416 13.5171 15.9166C13.5171 14.5916 14.5921 13.5166 15.9171 13.5166C17.2421 13.5166 18.3171 14.5916 18.3171 15.9166C18.3171 17.2416 17.2421 18.3166 15.9171 18.3166Z",
    fill: "#E66F15"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#EAEAEA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceive);
export default __webpack_public_path__ + "static/media/receive.9f72ffd57e4bb0dbf2a963521ee850e7.svg";
export { ForwardRef as ReactComponent };